import * as React from 'react';
import * as classNames from 'classnames';

interface IProps {
  fieldName: string;
  hasFocus: boolean;
  hasError: boolean;
}

const TokenizedField: React.StatelessComponent<IProps> = (props) => {
  const classes = classNames(
    'adyen-field', {
      'adyen-field--focused': props.hasFocus,
      'adyen-field--error': props.hasError,
    },
  );

  return (
    <div className={classes} data-cse={props.fieldName} />
  );
};

export default TokenizedField;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/tokenized_field.tsx